import { render, staticRenderFns } from "./HightLight.vue?vue&type=template&id=495a4799&scoped=true"
import script from "./HightLight.vue?vue&type=script&lang=js"
export * from "./HightLight.vue?vue&type=script&lang=js"
import style0 from "./HightLight.vue?vue&type=style&index=0&id=495a4799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a4799",
  null
  
)

export default component.exports